// todo un-hardcode the vat percentage
const VAT_PERCENTAGE = 1.21;

const VENDOR = {
    PROBO: 2,
    DEGROOT: 4,
};

export { VAT_PERCENTAGE, VENDOR };
